import { createStore as createReduxStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import createLogger from 'redux-logger'

export default function createStore(rootReducer) {
  const middlewares = [thunk]

  if (st.GLOBALS.RAILS_ENV === "development") {
    const logger = createLogger({
      collapsed: true
    })
    middlewares.push(logger)
  }

  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

  const store = createReduxStore(rootReducer, composeEnhancers(
    applyMiddleware(...middlewares)
  ))

  return store
}


// WEBPACK FOOTER //
// ./app/webpack/shared/utils/createStore.js